<template>
	<van-popup class="advertisement_-conter" v-model="isShow" z-index="2300">
		<div class="advertisement_list" >
				<div class="ZAJ3tO484KoZnr7Y6n_l" >
					{{model.title}}
				</div>
				
				<div style="padding: .2rem;">
					<div class="ui-dialog__message">
						<label>Total de apostas durante o evento:</label>
						<span>{{model.total||0}}</span>
					</div>
					<div class="ui-dialog__message">
						<label>Valor de sorte utilizado:</label>
						<span>{{model.use||0}}</span>
					</div>
					<div class="ui-dialog__message">
						<label>Valor da sorte expirado:</label>
						<span>{{model.expire||0}}</span>
					</div>
					<div class="ui-dialog__message">
						<label>Valor de sorte disponível:</label>
						<span>{{model.usable_str||0}}</span>
					</div>
				</div>
				
				
		</div>
		<div class="" style="display: flex;align-items: center;justify-content: center;margin-top: .4rem;">
			<img 
			 style="width: 0.5984rem;height: 0.5984rem;cursor: pointer;"
			 @click="$emit('cancel')"
			 src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII=" >
		</div>
	</van-popup>
</template>

<script>
	export default {
		props:{
			isShow:{
				type:Boolean,
				required:false,
			},
			model:{
				type:[Object,Array],
				required:{},
			}
		},
		data() {
			return {
				codeValue: '',
				CancelDisplay:false,
				inputFocus: false,
			};
		},
		created(){
			// window.localStorage.set('CancelDisplay',true)
			// CancelDisplay
			this.CancelDisplay=window.localStorage.getItem('CancelDisplay')=='true'
		},
		methods: {
			cunSltenmefals(){
				
			},
			isDepositOpen(){
				this.$store.commit('isDeposit',true);
				window.localStorage.setItem('CancelDisplay',false)
				this.CancelDisplay=false;
			},
			openUrl(e){
				if(e.jump_url && e.jump_url!='#'){
					this.$router.push({name:e.jump_url})
				}
			}
		},
	}
</script>
<style>
	.login-body{
		font-weight: 400;
	}
	.van-popup.advertisement_-conter{
		background-color: transparent; 
	}
	
</style>
<style scoped>
	.ui-dialog__message {
	    color: var(--skin__lead);
	    flex: 1;
	    overflow-y: auto;
	    font-size: .22rem;
	    line-height: 1.64;
	    letter-spacing: normal;
	    white-space: pre-wrap;
		text-align: left;
	    word-wrap: break-word;
	    -webkit-overflow-scrolling: touch;
		    margin: 0 .3rem .1rem 0;
			color: var(--theme-text-color);
	}
	.ui-dialog__message label{
		padding-right: .1rem;
		color: var(--cms-text-color-primary);
	}
	 html .ant-btn.ant-btn-primary{
		width: 5rem;
		font-size: .24rem;
	    background-color: var(--theme-primary-color);
	    border-color: var(--theme-primary-color);
		margin-top: 0;
		display: flex;
		margin: 0 auto;
		text-align: center;
		align-items: center;
		justify-content: center;
	}
	html .ant-btn.ant-btn-primary {
	    color: var(--theme-primary-font-color);
	    text-shadow: none;
		height: .7rem;
		border-radius: .14rem;
	}
	.ZAJ3tO484KoZnr7Y6n_l {
	    color: var(--cms-text-color-primary);
	    font-size: .3rem;
	    font-weight: 400
	}
	.fail{
		font-size: .3rem;
		font-weight: 400;
		color: var(--theme-secondary-color-error);
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.RlMZ1IA0k4zaYVTGjIiN {
	    color: var(--cms-text-color-primary);
	    font-size: .22rem;
	    margin-bottom: .4rem;
	    margin-top: .3rem;
	    min-height: .7rem
	}
	.advertisement_list{
		    width: 6rem;
			box-sizing: border-box;
			text-align: center;
			padding-top: .2rem;
			border: 0.01rem solid var(--theme-text-color);
			padding-bottom: .2rem;
			background-color: var(--cms-background-color-primary);
			border-radius: .2rem;
	}
	.advertisement_list .title{
		    color: var(--theme-text-color-darken);
			text-align: center;
			line-height: 1rem;
			font-size: .4rem;
	}
	._common-tabs-content{
		max-height: 5.4rem;
		width: 100%;
	}
	.consliTst{
		display: flex;
		align-items: center;
		border-radius: .1rem;
		height: .8rem !important;
		background-color: rgba(var(--theme-primay-color-hex), .05);
		max-width: 2.05rem;
		padding: .15rem;
		text-align: revert !important;
	}
	.consliTst svg{
		width: .38rem;
		height: .38rem;
		color: var(--theme-primary-color);
		    margin-right: .08rem;
	}
	.consliTst span{
		    font-size: .22rem;
			display: inline-block;
		    line-height: .28rem;
			flex: 1;
			    color: var(--theme-primary-color);
		    overflow: hidden;
		    text-overflow: ellipsis;
		    /* white-space: nowrap; */
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			display: -webkit-box;
				white-space: break-spaces !important;
	}
</style>